import React, { useContext, useState } from "react";
import { Form, Input, Button, message, notification } from "antd";
import "./style.css";
import passIcon from "../../../Assets/Icons/password.svg";
import mailIcon from "../../../Assets/Icons/mail.svg";
import leftImage from "../../../Assets/Icons/left-box.svg";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../App";
import { encryptText } from "../../../Utils/Encryption";
import updateUserStates from "../../../Utils/UpdateUsersState";
import { login } from "../../../API/auth";
import logo from "../../../Assets/Icons/company_icon.svg";

const Login = () => {
  const { userData, setUserData, setUserToken } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [notificationApi, contextHolder] = notification.useNotification();

  const onFinish = async (values) => {
    setLoading(true);
    const { email, password } = values;
    try {
      const loginData = await login({ email, password });

      if (loginData?.status === 200) {
        localStorage.clear();
        localStorage.setItem(
          encryptText("token"),
          encryptText(
            JSON.stringify({
              access: loginData?.data?.access,
              refresh: loginData?.data?.refresh,
            }),
          ),
        );

        localStorage.setItem(
          encryptText("user"),
          encryptText(
            JSON.stringify({
              id: loginData?.data?.id,
              role: loginData?.data?.role,
              name: loginData?.data?.name,
              email: loginData?.data?.email,
              phone: loginData?.data?.phone,
              verified: loginData?.data?.verified,
              profile_picture: loginData?.data?.profile_picture,
              permissions: loginData?.data?.permissions,
            }),
          ),
        );

        updateUserStates(setUserData, setUserToken);

        if (loginData?.data?.role === "admin") {
          navigate("/allusers");
        } else {
          navigate("/dashboard");
        }
      } else {
        // Invalid login
        notificationApi.error({
          message: "Invalid login details",
          description: "Kindly provide correct email and password",
        });
      }
    } catch (error) {
      console.error("Login failed:", error);
      notificationApi.error({
        message: "Login Error",
        description: "Something went wrong while logging in.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {contextHolder}
      <div className="left-side">
        <img src={leftImage} alt="Left Icon" className="left-icon" />
      </div>

      <div className="login">
        <div className="login-card">
          <div className="title">
            <div className="main" style={{ textAlign: "center" }}>
              Log in to SmartDefence
            </div>
            <div className="sub">
              Access your account to monitor vehicles, review alerts, and manage
              security settings.
            </div>
          </div>
          <Form
            name="login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Please enter a valid email!" },
              ]}
            >
              <Input
                type="email"
                prefix={
                  <img
                    src={mailIcon}
                    alt="email-icon"
                    className="site-form-item-icon"
                  />
                }
                placeholder="Email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please enter your Password!" },
              ]}
            >
              <Input.Password
                prefix={
                  <img
                    src={passIcon}
                    alt="password-icon"
                    className="site-form-item-icon"
                  />
                }
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={loading}
              >
                Log In
              </Button>
            </Form.Item>
          </Form>
          <div className="logo-wrapper">
            <img src={logo} alt="Logo Icon" className="logo-icon" />
            <div className="text">
              Powered by <span>CouSync</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
